import {useCallback, useEffect, useRef, useState} from "react";
import StrapiService from "../strapi/StrapiService";
import {useTranslation} from "react-i18next";
import MainLayout from "./MainLayout";

export default function MainPage() {
  const {i18n } = useTranslation();
  const [filters, setFilters] = useState({
    language: '',
    search: '',
    productsAndServices: '',
    fieldsAndProfiles: '',
    technologies: '',
    typeOfIndustries: '',
    companySizes: '',
    companyTypes: ''
  });

  const [industrieObjects, setIndustrieObjects] = useState([]);

  const [targetPosition, setTargetPosition] = useState(null);
  const [zoom, setZoom] = useState(null);
  const debounceRef = useRef(null);

  const handleFlyToIndustrieObjects = useCallback((industrieObjects) => {
    if (!industrieObjects || industrieObjects.length === 0) return;

    const coords = industrieObjects
      .map(obj => obj.Coordinates)
      .filter(c => c?.Latitude && c?.Longitude);

    if (coords.length === 0) return;

    const avgLat = coords.reduce((sum, c) => sum + c.Latitude, 0) / coords.length;
    const avgLng = coords.reduce((sum, c) => sum + c.Longitude, 0) / coords.length;
    setTargetPosition([avgLat, avgLng]);

    const maxDistance = Math.max(
      ...coords.map(c => Math.hypot(c.Latitude - avgLat, c.Longitude - avgLng))
    );

    let zoom;
    if (maxDistance < 0.01) zoom = 13;
    else if (maxDistance < 0.2) zoom = 12;
    else if (maxDistance < 0.5) zoom = 11;
    else zoom = 11;

    setZoom(zoom);
  }, []);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      StrapiService.getIndustrieObjectsWithFilters(filters, i18n.language).then(setIndustrieObjects);
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [filters, i18n.language]);

  return (
    <MainLayout industrieObjects={industrieObjects} filters={filters} setFilters={setFilters} handleFlyToIndustrieObjects={handleFlyToIndustrieObjects} targetPosition={targetPosition} zoom={zoom}/>
    )
}
